import styles from "@styles/forms-flow/creative.module.scss";
import React, { useState } from "react";

import { Button, Input } from "@components";
import { If } from "@components/control-statements";
import { Environment } from "@core/Environment";

import { useDebouncedCallback } from "@hooks";
import { FlowAPI } from "@providers/FlowAPI";

export const WhatsAppMessage = ({ template_id, coupon }) => {
	const [phone, setPhone] = useState("");
	const [remainTime, setRemainTime] = useState(0);
	const [isWaitingSending, setIsWaitingSending] = useState(false);

	const sendWhatsAppTest = async () => {
		if (validatePhoneAndPrefix()) {
			setIsWaitingSending(true);

			const response = await FlowAPI.sendMetaWhatsAppTest(Environment.id, {
				template_id: template_id,
				phone: `+55${phone}`,
				coupon_code: coupon?.code || null,
				coupon_value: coupon?.value || null,
				coupon_type: coupon?.type || null,
			});

			const errors = response.getErrors([]);

			if (errors.length > 0) {
				alert({ text: errors[0] });
				setIsWaitingSending(false);
				return;
			}

			setIsWaitingSending(false);
			const startTimer = () => {
				let startTime = 180;
				const intervalId = setInterval(() => {
					setRemainTime(startTime--);
					if (startTime == -1) {
						clearInterval(intervalId);
					}
				}, 1000);
			};
			startTimer();
		}
	};

	const onSendWhatsApp = sendWhatsAppTest;

	const handlePhoneChange = (e) => {
		const newValue = e.target.value;
		setPhone(newValue.replace(/\D/g, ""));
	};

	const validatePhoneAndPrefix = () => {
		const phoneValid = /^\(\d{2}\)\s\d{5}-\d{4}$/.test(
			`(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`
		);

		return phoneValid;
	};

	return (
		<>
			<p className={styles.label}>Enviar simulação</p>
			<p className={styles.sublabel}>
				Informe o seu número de telefone para que possamos realizar um disparo
				teste.
			</p>
			<div className={styles.testMessage}>
				<Input
					value={`(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(
						7
					)}`}
					onChange={handlePhoneChange}
					disabled={isWaitingSending}
					prefix="Telefone"
					prefixWidth={80}
					max="15"
				/>
				<Button
					design="four"
					className={`w-100 mt-15`}
					disabled={
						remainTime > 0 || isWaitingSending || !validatePhoneAndPrefix()
					}
					onClick={onSendWhatsApp}
				>
					Enviar simulação
					<If cond={remainTime > 0}>
						<span>
							&nbsp;(
							{`${`${Math.floor(remainTime / 60)}`.padStart(2, "0")}:${`${remainTime % 60
								}`.padStart(2, "0")}`}
							)
						</span>
					</If>
				</Button>
			</div>
		</>
	);
};

export default WhatsAppMessage;
